import { BaseService } from '../base';

export type PropertyClassification = {
  id: string;
  code: string;
  description: string;
};

export type PropertyClassificationsMeta = {
  pageNumber: number;
  pageSize: number;
  total: number;
  totalPages: number;
};

export type PropertyClassificationsResponse = {
  data: PropertyClassification[];
  meta: PropertyClassificationsMeta;
};

export type GetPropertyClassificationsParams = {
  sortType?: 'ASC' | 'DESC';
  sortField?: string;
  pageSize?: number;
  pageNumber?: number;
};

export class PropertyClassificationsService extends BaseService {
  constructor() {
    super(import.meta.env.VITE_API_URL);
  }

  async getPropertyClassifications(
    params: GetPropertyClassificationsParams = {}
  ): Promise<{
    success: boolean;
    data?: PropertyClassificationsResponse;
    error?: string;
  }> {
    try {
      const queryParams = new URLSearchParams();
      if (params.sortType) queryParams.set('sortType', params.sortType);
      if (params.sortField) queryParams.set('sortField', params.sortField);
      if (typeof params.pageSize === 'number') {
        queryParams.set('pageSize', params.pageSize.toString());
      }
      if (typeof params.pageNumber === 'number') {
        queryParams.set('pageNumber', params.pageNumber.toString());
      }

      const qs = queryParams.toString();
      const path = qs
        ? `/portal/v1/products/product-lines/homeowner/property-classifications?${qs}`
        : `/portal/v1/products/product-lines/homeowner/property-classifications?`;

      const response = await this.get(path);

      return await this.handleJsonResponse<PropertyClassificationsResponse>(
        response
      );
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar classificações do imóvel',
      };
    }
  }
}

export const propertyClassificationsService =
  new PropertyClassificationsService();
